import { Popper } from "@mui/material/";
import { styled, lighten, darken } from "@mui/system";
import { autocompleteClasses } from "@mui/material/Autocomplete";

const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: `-${theme.spacing(2)}`,
    padding: `${theme.spacing(2)} ${theme.spacing(2)}`,
    color: theme.palette.primary.main,
    backgroundColor:
        theme.palette.mode === "light"
            ? lighten(theme.palette.primary.light, 0.85)
            : darken(theme.palette.primary.main, 0.8),
}));

const StyledPopper = styled(Popper)(({ theme }) => ({
    [`& .${autocompleteClasses.listbox}`]: {
        boxSizing: "border-box",
        "& ul": {
            padding: 0,
            margin: 0,
        },
    },
    border: `1px solid ${theme.palette.border.lightBorder}`,
    boxShadow: `1px 1px 5px 1px ${theme.palette.background.mediumBackground}`,
}));

const GroupItems = styled("ul")({
    padding: 0,
});

export { GroupHeader, StyledPopper, GroupItems };
